import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Table, Tag, Spin, Empty } from 'antd';
import {
  ShoppingCartOutlined,
  DollarOutlined,
  TrophyOutlined,
  RiseOutlined,
  MoneyCollectFilled,
  EyeOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { ComboChart } from '../../components/Charts';
import './index.css';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const { data } = await axios.get('/api/dashboard/stats');
      setStats(data);
    } catch (error) {
      console.error('获取仪表盘数据失败:', error);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2 className="dashboard-title">仪表盘</h2>
        <p className="dashboard-subtitle">欢迎回来，这里是您的数据概览</p>
      </div>

      {/* 统计卡片 */}
      <div className="metric-grid">
        <div className="metric-card">
          <div className="metric-header">
            <span className="metric-icon metric-icon-purple">
              <ShoppingCartOutlined />
            </span>
            <span className="metric-title">当月订单</span>
          </div>
          <div className="metric-value">
            {stats?.metrics?.monthly_orders}
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <span className="metric-icon metric-icon-orange">
              <DollarOutlined />
            </span>
            <span className="metric-title">当月金额</span>
          </div>
          <div className="metric-value">
            {stats?.metrics?.monthly_amount}
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <span className="metric-icon metric-icon-brown">
              <TrophyOutlined />
            </span>
            <span className="metric-title">总订单数</span>
          </div>
          <div className="metric-value">
            {stats?.metrics?.total_orders}
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <span className="metric-icon metric-icon-blue">
              <RiseOutlined />
            </span>
            <span className="metric-title">总金额</span>
          </div>
          <div className="metric-value">
            {stats?.metrics?.total_amount}
          </div>
        </div>
      </div>

      <div className="charts-section">
        <Row gutter={[24, 24]}>
          <Col xs={24}>
            <ComboChart
              data={(stats?.chart?.monthly_stats || []).map(item => ({
                month: `${item.month}月`,
                orders: item.orders,
                revenue: item.amount
              }))}
              title="1-12月订单统计"
              barColor="#165dff"
              lineColor="#00b42a"
            />
          </Col>
        </Row>
      </div>

      




    </div>
  );
};

export default Dashboard;
